<main>
	<div class="row" style="padding: 20px;height: 100%;box-sizing: border-box;width: 90%">
		<div>    
			<h1>Privacy Statement for Smart Telemetrics Product and Services</h1>
			<h4>At Smart Charging Technologies, we take your privacy seriously.</h4>
		</div>

		<div>
			<p>
				This Privacy Statement for Smart Telemetrics describes information that Smart Charging Technologies LLC, and its subsidiaries and affiliates (collectively, “SCT”) collect, use, share, and store, including personal information (i.e., information that personally identifies you, such as your name, email address, billing information, or other data that can be reasonably used to infer the above).
			</p>
			<p>
				This document focuses on information related to the operation of Smart Telemetrics products and services.
			</p>
			<p>
				Our Pledge:
			</p>
			<ol>
				<li><u>We will be transparent</u> about the different types of information we collect and how we use them.</li>
				<li><u>We will ask for your permission</u> before sharing your personal information with third parties for purposes other than directly requested by you or in the provision of Smart Telemetrics products.</li>
				<li><u>We will use best-in-class data security tools</u> to keep your data safe and protect Smart Telemetrics products from unauthorized access.</li>
			</ol>
			<p>
				Permission for data collection and processing: By using Smart Telemetrics products, you agree to allow us to collect and process information as described in this Privacy Statement.
			</p>
			<p>
				International data transfers: Your personal information may be collected, processed and stored by Smart Charging Technologies or its service providers in the United States and other countries where our servers reside. Please be aware that the privacy protections and legal requirements, including the rights of authorities to access your personal information, in some of these countries may not be equivalent to those where you personally reside. If you are using Smart Telemetrics products in the European Economic Area or other regions with laws governing data collection and use that may differ from United States law, you agree to the transfer of your personal data to the United States and other countries where Smart Telemetrics operates. 
			</p>
			<br>
			<br>
			<h4>
				Our legal basis for processing information
			</h4>
			<p>
				If European data protection law applies to the processing of your information, we process your information for the purposes described in this Privacy Statement, based on the following legal grounds:
			</p>
			<p>
				<u>
					When we are providing a product or service
				</u>
			</p>
			<p>
				We process your data to provide and support a product or service you have requested under a contract, including but not limited to delivering our Terms of Service.
			</p>
			<p>
				<u>
					When we are pursuing legitimate interests
				</u>
			</p>
			<p>
				We process your information for our legitimate interests and those of third parties while applying appropriate safeguards that protect your privacy. This means we process your information for things like:
			</p>
			<ul>
				<li>offering and improving Smart Telemetrics products and services</li>
				<li>developing new products and features</li>
				<li>understanding how people use our products and services</li>
				<li>performing research that improves our services for our users and benefits the public</li>
				<li>sending you direct marketing and other communications from Smart Telemetrics</li>
				<li>protecting against harm to the rights, property, and safety of Smart Telemetrics, our users, and the public</li>
				<li>detecting, preventing or otherwise addressing fraud, abuse, security or technical issues with our services (including using CAPTCHA)</li>
				<li>maintaining and improving the integrity of our computing systems, and protecting our users’ data security</li>
				<li>enforcing legal claims, including investigation of potential violations of applicable Terms of Service</li>
			</ul>
			<p>
				<u>
					When we are complying with legal obligations
				</u>
			</p>
			<p>
				We process your data when we have a legal obligation to do so, for example, if we are responding to a legal process or an enforceable governmental request.
			</p>
			<p>
				We ask for your consent to process your information for certain specific purposes and give you the right to withdraw that consent at any time.
			</p>
			<h4>
				During which circumstances does Smart Telemetrics share my information?
			</h4>
			<p>
				Under no circumstance do we share personal information for any commercial or marketing purpose unrelated to the activation and delivery of Smart Telemetrics Products and Services without asking you first. Period. We do not rent or sell our customer lists. The following are the limited situations where we may share personal information:
			</p>
			<ul>
				<li>
					We may share personal information when we have your permission. One example of this would be if you invite another user to access the products on your account as an additional authorized user. 
				</li>
				<li>
					As part of business transitions: Upon the sale or transfer of the company and/or all or part of its assets, your personal information may be among the items sold or transferred. We will request a purchaser to treat our data under the privacy statement in place at the time of its collection.
				</li>
				<li>
					For legal reasons: We will share personal information with third parties if we have a good faith belief that access, use, preservation or disclosure of the information is reasonably necessary to (i) meet any applicable law, regulation, legal process or enforceable government request; (ii) enforce Smart Telemetrics policies or contracts, including investigation of potential violations; (iii) detect, prevent or otherwise address fraud, security or technical issues; (iv) protect against harm to the rights, property or safety of Smart Telemetrics, our users or the public as required or permitted by law.
				</li>
			</ul>
			<p>
				We may share non-personal information (for example, aggregated or anonymized customer data) publicly and with our partners. For example, we may publish trends about power outages, or help us generally improve our system.
			</p>
			<p>
				If you select an outside party for the purchase, installation or service of your Smart Telemetrics device and share your personal information, we cannot control the collection, storage or sharing of information collected by that party. For example, if you buy an Smart Telemetrics from a retailer, the retailer may collect personal information as part of the transaction. Or the party that installed the device may retain information that you provided to them to assist them in servicing the device if needed. Always check the privacy policies for any company that collects your personal information.
			</p>
			<h4>
				What choices do I have and how can I delete my personal information?
			</h4>
			<p>
				Smart Telemetrics generally stores your personal information on Smart Telemetrics servers until you delete or edit it, or for as long as you remain a Smart Telemetrics customer in order to provide you with Smart Telemetrics products. In addition, Smart Telemetrics may store your personal information to resolve disputes, establish legal defenses, conduct audits, pursue legitimate business purposes, enforce our agreements and comply with applicable laws.
			</p>
			<p>
				As described above, some information is processed and stored directly on the Smart Telemetrics device. Personal information from Smart Telemetrics devices is encrypted while it is being transmitted to Smart Telemetrics.
			</p>
			<p>
				You can delete the information on the Smart Telemetrics device by resetting it to the default settings (using the Smart Telemetrics App, Cloud or reset button).
			</p>
			<p>
				You can access, amend or delete your personal information from Smart Telemetrics servers through the controls in your account. 
			</p>
			<p>
				Individual Rights in the European Economic Area.
			</p>
			<p>
				If you are located in the European Economic Area, you may seek confirmation regarding whether Smart Telemetrics is processing personal information about you, request access to your personal information and ask that we correct, amend or delete your personal information. In addition, you may object to Smart Telemetrics processing of your personal information at any time. However, doing so may impact your use of the products and services.
			</p>
			<p>
				If applicable law provides you the right to request access to, (receive) port, object to or restrict processing, seek rectification or request erasure of personal information held about you by Smart Telemetrics, you may do so, as applicable, through controls in the Smart Telemetrics application or by contacting Smart Telemetrics.
			</p>
			<h4>
				Minors.
			</h4>
			<p>
				Only individuals aged 18 and older are permitted to act as the primary holders of Smart Telemetrics accounts. Authorized users must be over the age of 13 (or equivalent minimum age in the jurisdiction where they reside) and may use the products and services under the supervision of a parent or legal guardian and only if they agree to be bound by these terms on the minor’s behalf. Smart Telemetrics products and services do not knowingly collect or store any personal information from anyone under the age of 13.
			</p>
			<h4>
				Can the Privacy Statement be changed?
			</h4>
			<p>
				Please note that this Privacy Statement may change from time to time. We will provide notice of any changes on the website or by contacting you.
			</p>
			<h4>
				How can I contact Smart Telemetrics?
			</h4>
			<p>
				For users in the United States and other countries:
			</p>
			<p>
				Smart Charging Technologies LLC.
			</p>
			<p>
				574 Econ River Pl
			</p>
			<p>
				STE #1050
			</p>
			<p>
				Oviedo, FL 32765
			</p>
			<br>
			<br>
			<p>
				If you have any questions, you may submit an inquiry online or by email: <a href="mailto:Info@smarttelemetrics.com">Info@smarttelemetrics.com</a>.
			</p>
		</div>
	</div>
</main>